<template>
    <div>
        <app-header></app-header>
        <main id="page-main">

            <div>
                <router-view @refresh="refresh()"></router-view>
                <header class="content-header">
                    <div class="wrapper">

                        <div>
                            <h1>Médias</h1>
                            <p>Gestion des médias</p>
                        </div>

                        <div class="actions">
                            <ul>
                                <li><button @click="importFile()"><span>Importer</span></button></li>
                            </ul>
                        </div>

                    </div>
                </header>
                <div class="content-body">

                    <section>
                        <div class="search">
                            <div><input type="text" placeholder="Recherche" v-model="query"/></div>
                            <!--
                            <div>
                                <ul>
                                    <li><button><span>Menu 1</span></button></li>
                                    <li><button><span>Menu 1</span></button></li>
                                    <li><button><span>Menu 1</span></button></li>
                                </ul>
                            </div>
                            -->
                        </div>

                        <h2 class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</h2>

                        <div class="medias">
                            <div v-for="item in resources">
                                <figure v-bind:style="{ backgroundImage: 'url('+item.url+')' }">
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="/>
                                </figure>
                                <input type="text" :value="item.original_filename"/>
                            </div>
                        </div>

                    </section>

                    <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

                </div>
            </div>

        </main>
    </div>
</template>
<script>

    import MediaService from './MediaService.js';
    import Index from '../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                uploads: []
            }
        },
        mounted: function(){
        },
        methods: {
            getResource: function(){
                return {name: 'media', api: MediaService};
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/media/Index.vue